import React, { useRef, useEffect } from "react"

import InsightsView from "../InsightsView/"
import DataLoader, { factors } from "../DataLoader"
import CountryFactorBarGraph from "../CountryFactorBarGraph"
import useDimensions from "react-use-dimensions"
import { useSmallWidthMode } from "../utils/smallWidthMode"
import classnames from "classnames"
import ReactMarkdown from "react-markdown"
import "./styles.scss"
import { Helmet } from "react-helmet"
export const factorHeaderLabels = [
  ["GLOBAL", "RANK"], // hmm should this change if a Region is selected??
  ["Government", "Powers"],
  ["Absence of", "Corruption"],
  ["Open", "Government"],
  ["Fundamental", "Rights"],
  ["Order and", "Security"],
  ["Regulatory", "Enforcement"],
  ["Civil", "Justice"],
  ["Criminal", "Justice"],
  ["OVERALL", "SCORE"],
]

function Factors(props) {
  const [containerRef, , containerNode] = useDimensions()
  const factorGraphRef = useRef()
  const inSmallWidthMode = useSmallWidthMode()

  const {
    selectedFactor,
    selectedYear,
    selectedCountry,
    setOverrideMapVisibility,
  } = props
  const factorSelected = selectedFactor !== ""

  const cardFactorIndex = factors.indexOf(selectedFactor)
  const factorNumber = cardFactorIndex + 1
  const countryData = DataLoader.dataByYear[selectedYear].countries.find(
    (country) => country.Country === selectedCountry,
  )

  const { aggregateFactorKeys } = DataLoader.dataByYear[selectedYear]

  const factorsToDisplay = factorSelected
    ? DataLoader.dataByYear[selectedYear].questionKeys.filter(
        (questionKey) => questionKey[0] === `${cardFactorIndex + 1}`,
      )
    : DataLoader.dataByYear[selectedYear].aggregateFactorKeys

  const factorDisplay = factorsToDisplay.map((subfactor, subfactorIndex) => {
    let subfactorKey = subfactor.split(" ")[0]
    subfactorKey =
      subfactorKey[subfactorKey.length - 1] === "."
        ? subfactorKey.substr(0, subfactorKey.length - 1)
        : subfactorKey
    const textKey = `${
      factorSelected ? `Sub-Factor ${subfactorKey}` : subfactor.split(":")[0]
    } Description`
    const subfactorText = DataLoader.getCopy(textKey)
    return (
      <div key={subfactorIndex} className="subfactor">
        <div className="subfactorTitle">{subfactor}</div>
        <div className="subfactorDescription">
          <ReactMarkdown>{subfactorText}</ReactMarkdown>
        </div>
        <CountryFactorBarGraph
          countryData={countryData}
          selectedYear={selectedYear}
          scoreKey={subfactor}
          axis={false}
          gotoCountryPage={props.gotoCountryPage}
          selectedCountry={selectedCountry}
        />
      </div>
    )
  })
  const nextFactorValue = factors[cardFactorIndex + 1]
  const nextFactorLabel =
    cardFactorIndex === factors.length - 1
      ? null
      : factorHeaderLabels[cardFactorIndex + 2].join(" ")
  const nextFactorButton = nextFactorLabel ? (
    <div
      onClick={() => props.updateUrl("factor")(nextFactorValue)}
      className="nextFactor"
    >
      {nextFactorLabel}
      <span className="arrow"></span>
    </div>
  ) : null

  const factorKey = factorSelected
    ? aggregateFactorKeys.find((k) => k.includes(props.selectedFactor))
    : "overall"
  const factorTitle = factorSelected
    ? selectedFactor
    : "WJP Rule of Law Index Factors"

  useEffect(() => {
    const cachedRef = factorGraphRef.current
    const observer = new IntersectionObserver(
      ([e]) => setOverrideMapVisibility(e.intersectionRatio < 0.99),
      { threshold: [0.99] },
    )

    observer.observe(cachedRef)

    return function () {
      observer.unobserve(cachedRef)
    }
  }, [setOverrideMapVisibility])
  useEffect(() => {
    if (containerNode) {
      const scrollDomNode = inSmallWidthMode
        ? document.documentElement
        : containerNode
      scrollDomNode.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }, [selectedFactor, containerNode, inSmallWidthMode])

  const scrollHeight = props.headerHeight
    ? window.innerHeight - props.headerHeight
    : null
  const factorText = factorSelected
    ? DataLoader.getCopy(`Factor ${factorNumber} Description`)
    : DataLoader.getCopy("Overview Description")
  return (
    <div className="Factors">
      <Helmet>
        <title>
          WJP Rule of Law Index | {factorSelected ? factorTitle : "Factors"}{" "}
        </title>
        <meta name="description" content={factorText.replace(/_/g, "")} />
      </Helmet>
      <div
        className="content"
        ref={containerRef}
        style={{ height: scrollHeight }}
      >
        <div className="factorGraph" ref={factorGraphRef}>
          <CountryFactorBarGraph
            countryData={countryData}
            selectedYear={selectedYear}
            scoreKey={factorKey}
            axis={false}
            gotoCountryPage={props.gotoCountryPage}
            selectedCountry={selectedCountry}
          />
        </div>
        <div className={classnames("title", { factorSelected })}>
          {factorTitle}
        </div>
        <div className="factorContent">
          <div className="factorDescription">
            <div
              className="factorTitle"
              style={{ marginBottom: factorSelected ? null : "1em" }}
            >
              {factorSelected
                ? "Explore rankings by factor components"
                : "Explore rankings by factor components"}
            </div>
            <ReactMarkdown>{factorText}</ReactMarkdown>
          </div>
          <div className="subfactors">
            {factorDisplay}
            {nextFactorButton}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function FactorsControls(props) {
  return (
    <InsightsView {...props}>
      <Factors />
    </InsightsView>
  )
}
